import React from 'react';
import './Copies.scss';
import { motion } from 'framer-motion';

function Copy5() {
  return (
    <section className="copies marginBottomAdd">
      <h4 className="copies__title title">Creating a Sense of Community</h4>
      <p className="copies__copy">
        Despite its physical appearance, one thing Boey and other eczema patients want you to know
        is that eczema is not contagious. “I remember as a kid, parents telling their kids not to
        play with me because I had these strange welts on my elbows and knees, and they didn’t know
        what it was.”
      </p>
      <p className="copies__copy">
        To help combat feelings of isolation, many have found connecting with others to be a great
        step towards healing emotionally. Boey says he strives to be a role model, or even just
        someone that other “eczema warriors” can connect with.
      </p>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1, type: 'tween' }}
        className="pullQuote"
      >
        “When I was growing up, I wish I had [eczema] role models,” he says.{' '}
        <span style={{ fontStyle: 'bold' }}>
          “I wish I had people to look up to, and I wish someone told me
        </span>{' '}
        that there are other people in the world who have the same condition as you.”
      </motion.p>

      <p className="copies__copy">
        A stint on a popular fashion-reality TV series actually led to peace for Boey. “I started to
        get fan mail from people who had eczema. And they said, ‘Thank you for appearing on screen
        with the condition that you have because you’ve given us the courage to go out.’” He notes
        that he answered every person. “We all share the same journey, and I never realized that
        media [was so powerful] until I appeared [on TV].” Boey says he also received a lot of
        letters and emails after publishing a book detailing his experiences with eczema.
      </p>
      <p className="copies__copy">
        Mack also stressed the importance of finding community. “Even following social media
        accounts of others living with eczema can reduce the sense of isolation and self-blame,” she
        says. “Please understand that it is not your fault, and you deserve relief.”
      </p>
    </section>
  );
}

export default Copy5;
